import styled from 'styled-components';

export const BoldFont = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold} ;
`

export const DataHeading = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-weight: ${props => props.theme.fontWeight.normal};
font-size: ${props => props.theme.fontSize.primary};
font-style: normal;
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.textColor};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
}
`;

export const DataVal = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.thead};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.headingColor};
  }
`;

export const TdHeading = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.primary};
font-style: normal;
line-height: 1.43;
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.headingColor};
margin-bottom:10px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  padding-right: ${props => props.mPaddingRight?props.mPaddingRight:'0px'}
  margin-bottom:0px;
  overflow-wrap: normal;
}
`;
export const TdValue = styled.div`
font-family: ${props => props.theme.fontFamily.HelveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
font-style: normal;
line-height: 1.43;
letter-spacing: ${props => props.theme.letterSpacing.zero};
color: ${props => props.theme.fontColors.thead};
margin-bottom:10px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
}
`;

export const TxnVal = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.tableFont};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.primary};
  text-decoration: ${props => !props.isDisabled ? 'underline': 'none'};
  cursor: ${props => !props.isDisabled ? 'pointer': 'default'}  ;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
  }
`;

export const EmptyMessage = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.thead};
  line-height: 1.5;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.heading};
  }
`;